<template>
  <section class="nph-module">
    <!-- <a href="https://giphy.com/bublywater" target="_blank" class="bubble"><span>see more<br>at giphy</span></a> -->
    <bubble-text extUrl="https://giphy.com/bublywater" class="light-blue">
      <span>see more<br>at giphy</span>
    </bubble-text>
    <div class="Grid Grid--1of2">     
      <div class="Grid-cell Grid-cell-left">
        <img src="./../assets/buble_like.gif" alt="like">
        <!-- <video loop autoplay playsinline muted ref="video1" poster="../assets/buble_heart_poster.jpg"></video>  -->
      </div>

      <div class="Grid-cell Grid-cell-right">
        <img src="./../assets/buble_approves.gif" alt="Buble approves">
        <!-- <video loop autoplay playsinline muted ref="video2" poster="../assets/burst_your_buble_poster.jpg"></video>  -->
      </div>
    </div>
  </section>
</template>

<script>
  import bubbleText from '@/components/bubbleText';

  export default {
    name: 'nph',
    components: {
      bubbleText
    },
    mounted() {
      this.screenSize = '';      
      this.setVideoSrc();
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.setVideoSrc);
    },

    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('scroll', this.setVideoSrc);
    },

    methods: {
      setVideoSrc(){       
        let screenSize = (window.innerWidth < 768) ? 'mobile' : 'desktop';

        // return if no breakpoint is crossed
        if (screenSize === this.screenSize) return;
        if (!this.$refs.video1 || !this.$refs.video1) return;

        if (screenSize === 'mobile'){
          this.screenSize = 'mobile';

          this.$refs.video1.setAttribute('src', 'static/videos/buble_heart.mp4');
          this.$refs.video2.setAttribute('src', 'static/videos/burst_your_buble.mp4');
        } else {
          this.screenSize = 'desktop';
          this.$refs.video1.setAttribute('src', 'static/videos/buble_heart.mp4');
          this.$refs.video2.setAttribute('src', 'static/videos/burst_your_buble.mp4');
        }
      },
      isInViewport(element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
          rect.bottom >= 0 &&
          rect.top <= (window.innerHeight || html.clientHeight)
        );
      },
      handleScroll() {
        const videos = [this.$refs.video1, this.$refs.video2];

        videos.map((i) => {
          if (i) {
            if (this.isInViewport(i)){
              // i.load();
              i.play();
            } else {
              var isPlaying = i.currentTime > 0 && !i.paused && !i.ended && i.readyState > 2;
              if (isPlaying) {
                i.pause();
              }
            }
          }
        });
      } 
    }
  };
</script>

<style lang='scss' scoped>
  @import './../variables';
  $bubble-radius: 120px;
  $bubble-radius-desktop: 174px;

  .nph-module {
    position: relative;
    overflow: hidden;
    // height: 9000px;
  }

  .Grid-cell-left {
    background-color: #1d1538;
  }

  .Grid-cell-right {
    background-color: #1d1538;
  }

  .Grid-cell {
    justify-content: center;
    align-items: center;
    flex-direction: column;
    display: flex;
    box-sizing: border-box;
  }

  video, img {
    width: 100%;
    height: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/NPH.vue